<style lang='less' scoped>
@import url('../../styles/common.less');
.work-flow {
   .title {
      font-size: 16px;
      color: #4680ff;
      line-height: 22px;
      padding-bottom: 12px;
      font-weight: 700;
      border-bottom: 1px solid #eaecf2;
      margin-bottom: 10px;
   }
   &__node {
      margin-bottom: 12px;
      padding-top: 8px;
      display: flex;
      &:last-child {
         margin-bottom: 0px;
         .node-depart::after {
            display: none;
         }
      }
      .node-form {
         flex: 1;
         margin-left: 27px;
         ::v-deep(tr){ vertical-align: baseline; }
         ::v-deep(td){
             width: 33.33%;
             margin-right: 24px;
         }
         ::v-deep(.el-descriptions__body){ background-color: #f9faff; padding: 12px 12px 0 12px; border-radius: 4px; }
         ::v-deep(.el-descriptions__label){ color: #91949f; }
         ::v-deep(.el-descriptions__content){color: #222327; font-weight: 400;  }
         ::v-deep(.green-text){ font-size: 16px; font-weight: 400;  }
         ::v-deep(.red-text){ font-size: 16px; font-weight: 400;  }
         .node-form-box{ .cf(); background-color: #f9faff; padding: 12px 12px 0 12px; border-radius: 4px; display: flex; flex-wrap: wrap;
            .node-form-item{ width: 32.33%; float: left; margin-bottom: 12px; margin-right: 1%;
               .el-descriptions__label{ font-size: 14px; }
               .el-descriptions__content{ font-size: 14px;
                  .file-name-address{ color: #409eff; }
                  .file-name-address:hover{ text-decoration: underline; cursor: pointer; }
               }
            }
         }
      }
      .node-depart {
         width: 78px;
         display: flex;
         flex-direction: column;
         align-content: center;
         align-items: center;
         font-size: 12px;
         color: #5a5d68;
         text-align: center;
         position: relative;
         &::after {
            content: "";
            position: absolute;
            width: 2px;
            background-color: #e4e5ea;
            top: 0px;
            bottom: -12px;
            z-index: 1;
         }
         &--name {
            font-size: 14px;
            font-weight: bold;
            color: #222327;
            padding-bottom: 8px;
            position: relative;
            background: #fff;
            z-index: 9;
         }
         .is-avatar {
            .avatar-append {
               display: none;
            }
            .avatar-name {
               display: block;
               background-color: #409eff;
            }
            .round {
               position: absolute;
               display: flex;
               width: 16px;
               height: 16px;
               background-color: #f04961;
               border-radius: 50%;
               right: -2px;
               top: -2px;
               border: 1px solid #fff;
               align-items: center;
               justify-content: center;
               cursor: pointer;
               .el-icon-close {
                  color: #fff;
                  font-weight: bold;
               }
            }
         }
         &__avatar {
            width: 36px;
            height: 36px;
            position: relative;
            box-sizing: border-box;
            background: #fff;
            z-index: 9;
            .avatar-name {
               display: none;
            }
            .avatar-append {
               border-radius: 50%;
               height: 100%;
               width: 100%;
               border: 2px dashed #e4e5ea;
               box-sizing: border-box;
               cursor: pointer;
               position: relative;
               &::before {
                  width: 2px;
                  height: 20px;
                  background-color: #91949f;
                  content: "";
                  display: block;
                  position: absolute;
                  left: calc(50% - 1px);
                  top: calc(50% - 10px);
               }
               &::after {
                  height: 2px;
                  width: 20px;
                  background-color: #91949f;
                  content: "";
                  display: block;
                  position: absolute;
                  top: calc(50% - 1px);
                  left: calc(50% - 10px);
               }
            }
         }
         &__staff-name {
            color: #5a5d68;
            font-weight: 400;
            font-size: 12px;
            padding-top: 8px;
            padding-bottom: 8px;
            background-color: #fff;
            position: relative;
            z-index: 9;
            min-width: 2px;
         }
      }
   }
   .current-task{ display: flex; align-items: center;
      .title{ margin-bottom: 0; border-bottom: none; padding-bottom: 0; }
      span{ 
         color: #FF576B;
         font-weight: 400;
         font-size: 16px;
         margin-left: 16px;  
         em{
            font-style: normal;
            vertical-align: baseline;
         } 
      }
   }
   ::v-deep(.el-empty){ padding: 20px 0;}
   ::v-deep(.el-empty__image){ width: 80px; }
}
</style>
<template>
   <div class="work-flow">
      <div style="margin-bottom: 30px" v-if="data.flowList && data.flowList.length > 0">
         <div class="title">审核结果</div>
         <div
            class="work-flow__node"
            v-for="(node, index) in data.flowList"
            :key="index"
         >
            <!-- 左侧 -->
            <div class="node-depart">
               <!-- 部门名称 -->
               <!-- 头像 -->
               <!-- 名字 -->
               <div class="node-depart--name">{{ node.actName }}</div>
               <div
                  class="node-depart__avatar"
                  :class="[node.assignee ? 'is-avatar' : '']"
               >
                  <div
                     class="avatar-append"
                  ></div>
                  <el-avatar class="avatar-name" :size="36">
                     {{ node.assigneeName && node.assigneeName.substr(0, 1) }}
                  </el-avatar>
               </div>
               <div class="node-depart__staff-name">
                  {{ node.assigneeName }}
               </div>
            </div>
            <!-- 右侧 -->
            <div class="node-form">
               <div class="node-form-box">
                  <div class="node-form-item" v-for="(dItem,dIndex) in node.aproveData" :key="dIndex">
                     <span class="el-descriptions__label">{{dItem.key}}:</span>
                     <span class="el-descriptions__content" v-if="dItem.key_p !== 'file_label'">
                        <span :class="{'red-text': (dItem.key_p === 'p_99_label' && (dItem.value === '不同意' || dItem.value.indexOf('退回') !== -1 || dItem.value === '撤销')),'green-text': (dItem.key_p === 'p_99_label' && dItem.value === '同意') }">{{dItem.value}}</span>
                     </span>
                     <span class="el-descriptions__content" v-else>
                        <span v-if="dItem.value === '无'">无附件</span>
                        <span v-else style="">
                           <span style="color: #409eff; text-decoration:underline; margin-right: 10px; cursor: pointer;" v-for="item in dItem.value" :key="item.fileId" @click="previewFn(item)">{{item.fileName}}</span>
                           <!-- <el-image style="width: 32px; height: 32px; margin-right: 6px;" v-for="item in dItem.value" :key="item.fileId" :src="item.fileUrl" :fit="'fill'"></el-image> -->
                        </span>
                     </span>
                  </div>
               </div>
               <!-- <el-descriptions>
                  <el-descriptions-item width="33.33%" v-for="(dItem,dIndex) in node.aproveData" :key="dIndex" :label="`${dItem.key}:`"><span :class="{'red-text': (dItem.key_p === 'p_99_label' && dItem.value === '不同意'),'green-text': (dItem.key_p === 'p_99_label' && dItem.value === '同意') }">{{dItem.value}}</span></el-descriptions-item>
               </el-descriptions> -->
            </div>
         </div>
      </div>
      <div v-if="data.currentTask && data.currentTask.length > 0 && !data.isCurrentUser"> 
         <div class="current-task">
            <div class="title">下一流程审批人:</div>
            <span 
               v-for="(node, index) in data.currentTask"
               :key="index">{{ node.actName }}<em v-if="node.actName"> - </em>{{ node.assigneeName }}</span>
         </div>
      </div>
      <!-- <div v-if="data.currentTask && data.currentTask.length === 0"> 
         <div class="current-task">
            <div class="title">下一流程审批人:</div>
            <span>流程结束</span>
         </div>
      </div> -->
      <ElImageViewer
         v-if="data.showViewer"
         :hide-on-click-modal="true"
         :url-list="data.imageList"
         @close="
            () => {
               data.showViewer = false;
            }
         "
      />
   </div>
</template>

<script lang="ts">
/* eslint-disable */
import {
   defineComponent,
   PropType,
   onMounted,
   reactive,
   toRef,
   toRefs,
   ref,
   computed,
   watch,
   onActivated
} from "vue";
import { ElImageViewer } from "element-plus";
import $api from "@/api/main";
import utils from '@/utils/utils';
import Bus from "@/bus";
import { baseURL, privewURL } from "@/utils/request";
import { flowHooks } from "@/hooks/factoryHooks";

export default defineComponent({
   props: {
      /**
       *  当前流程id
       */
      processInstanceId: {
         type: String,
         default: '',
      },
   },
   setup(props, ctx) {
      const data: any = reactive({
            flowList: [],
            currentTask:[],
            imageList:[],
            showViewer: false,
            isCurrentUser: false
        });

      // 获取工作流程详情
      const getProcessTaskCirculationFn = async ()=>{
         let result = await $api.getProcessTaskCirculation(props.processInstanceId);
         if(result){
            result.forEach((item:any)=>{
               item.message = JSON.parse(item.message);
               if(item.message !== null){
                  let approveData:any = [];
                  let arr = Object.getOwnPropertyNames(item.message).filter((fItem)=>{ return fItem.indexOf('label') !== -1 });
                  arr.forEach((aItem:any)=>{
                     let json:any = {};
                     if(aItem.split('_').length === 3){
                        json.value = item.message[`${aItem.split('_')[0]}_${aItem.split('_')[1]}`] || '无'
                     }else{
                        if(aItem.split('_')[0] === 'finesConfirm' && item.message[`${aItem.split('_')[0]}`] === false){
                           json.value = '未缴纳';
                        }else if(aItem.split('_')[0] === 'finesConfirm' && item.message[`${aItem.split('_')[0]}`] === true){
                           json.value = '已缴纳';
                        }else{
                           json.value = item.message[`${aItem.split('_')[0]}`] || '无'
                           // if(aItem.indexOf('Amount') !== -1){
                           //    json.value = utils.$currency(item.message[`${aItem.split('_')[0]}`], { symbol: '¥' }).format();
                           // }else{
                           //    json.value = item.message[`${aItem.split('_')[0]}`] || '无'
                           // }
                        }
                     }
                     json.key = item.message[aItem];
                     json.key_p = aItem;

                     if((json.key.indexOf('金额') !== -1 && json.key.indexOf('进度款金额是否合理') === -1) || json.key.indexOf('累计已付款') !== -1){
                        json.value = utils.$currency(json.value, { symbol: '¥' }).format();
                     }

                     if(json.key_p === 'file_label' && json.value !== '无'){
                        json.value.forEach((item:any) => {
                           item.fileUrl = `${baseURL}public/file/${item.fileId}?token=${utils.$cookie.getCookie(
                              utils.$tokenStr
                           )}`
                        });
                     }
                     if(json){
                        approveData.push(json);
                     }
                  });
                  approveData.push({
                     key:'审核时间',
                     value: item.endTime,
                  });
                  let delIndex = approveData.findIndex((item: any)=>{ return item.key === '审核结果' });
                  let delItem = approveData[delIndex];
                  if(delItem){
                     approveData.splice(delIndex,1);
                     approveData.unshift(delItem);
                  }
                  item.aproveData = approveData;
               }
            });
         }
         data.flowList = result;
         let reverseResult = JSON.parse(JSON.stringify(result)).reverse();
         let reverseArr:any = [];
         reverseResult.forEach((item:any) => {
            if(item.message){
               for(let key in item.message){
                  if(key === 'agreePayAmount'){
                     reverseArr.push({key:'agreePayAmount',value:item.message[key]});
                     Bus.$emit("thorwAgreePayAmount",item.message[key]);
                  }
                  if(key === 'agreePaymentLabourAmount'){
                     reverseArr.push({key:'agreePaymentLabourAmount',value:item.message[key]});
                     Bus.$emit("thorwAgreePaymentLabourAmount",item.message[key]);
                  }
                  if(key === 'agreePaymentMaterialAmount'){
                     reverseArr.push({key:'agreePaymentMaterialAmount',value:item.message[key]});
                     Bus.$emit("thorwAgreePaymentMaterialAmount",item.message[key]);
                  }
               }
            }
         });
         if(reverseArr.length > 0){
            reverseArr.reverse().forEach((item:any)=>{
               switch (item.key) {
                  case 'agreePayAmount':
                     Bus.$emit("thorwAgreePayAmount",item.value);
                     break;
                  case 'agreePaymentLabourAmount':
                     Bus.$emit("thorwAgreePaymentLabourAmount",item.value);
                     break;
                  case 'agreePaymentMaterialAmount':
                     Bus.$emit("thorwAgreePaymentMaterialAmount",item.value);
                     break;
               }
            });
         }else{
            Bus.$emit("thorwAgreePayAmount",0);
            Bus.$emit("thorwAgreePaymentLabourAmount",0);
            Bus.$emit("thorwAgreePaymentMaterialAmount",0);
         }
      }

      // 获取下一个流程审批人
      const getCurrentTaskInfoFn = async ()=>{
         data.currentTask = [];
         data.isCurrentUser = false;
         let result = await $api.getCurrentTaskInfo(props.processInstanceId);
         if(result && result.length > 0){
         data.currentTask = result;
         data.isCurrentUser = utils.$cookie.getCookie('hxUserCode') === result[0].assignee;
         }
      }

      const previewFn = (val:any)=>{
         if (
            val.fileName.indexOf("png") === -1 &&
            val.fileName.indexOf("jpg") === -1 &&
            val.fileName.indexOf("jpeg") === -1
         ) {
            window.open(
               `${baseURL}public/file/${val.fileId}?token=${utils.$cookie.getCookie(
                  utils.$tokenStr
               )}`
            );
         } else {
            data.imageList.push(val.fileUrl);
            data.showViewer = true;
         }
      }

      /**
      * 监听processInstanceId变化
      */
      watch(()=>props.processInstanceId,(val)=>{
         if(val){
               getProcessTaskCirculationFn();
               getCurrentTaskInfoFn();
         }
      })
      

      onMounted(() => {
         if(props.processInstanceId){
            getProcessTaskCirculationFn();
         }
      });
      onActivated(() => {
         if(props.processInstanceId){
            getProcessTaskCirculationFn();
         }
      });

      return {
         data,
         previewFn
      };
   },
});
</script>
